export const STORAGE_KEYS = {
  LAST_SELECTED_LANGUAGE: 'last_selected_language',
  SELECTED_ROLE: 'selected_role',
};
